<template>
    <dfn class="translation">
        <dfn :contenteditable='editMode' @click="textFocus; setEditMode" @blur="textBlur; cancelEdit" @keydown="manageEnterEsc" :class="editMode ? 'editMode' : ''">
            {{text}}
        </dfn>
        <p v-if="editMode && foreignLanguage" class="frText">
            {{frenchText}}
        </p>
    </dfn>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        data() {
            return {
                editMode: false
            }
        },
        computed: {
            ...mapGetters([
                'frenchTexts',
                'babelMode',
                'foreignLanguage'
            ]),
            key: function() {
                let emptyAttrs = Object.keys(this.$attrs).filter(key => this.$attrs[key] == "");
                if (emptyAttrs.length < 1) return 'default';
                return emptyAttrs[0];
            },
            text: function() {
                return this.$t(this.key);
            },
            frenchText: function() {
                if (!this.frenchTexts) return '';
                return this.frenchTexts[this.key] ? this.frenchTexts[this.key] : '❔ ' + this.key + ' ❔';
            }
        },
        methods: {
            ...mapActions([
                'textFocus',
                'textBlur'
            ]),
            setEditMode(e) {
                if (!this.babelMode) return false;
                if (!e.ctrlKey) return false;
                e.preventDefault();

                if (this.editMode) {
                    return false;
                }

                this.editMode = true;

                return true;
            },

            async manageEnterEsc(e) {
                if (e.key == "Escape") {
                    e.preventDefault();
                    this.cancelEdit(e);
                    return;
                }
                if (e.key == "Enter") {
                    e.preventDefault();
                    await this.saveText(e.target.innerText);
                    this.cancelEdit(e);
                    return;
                }
            },

            async saveText(text) {
                let translation = {
                    key: this.key,
                    text: text
                }
                await this.$store.dispatch('setTranslation', translation);

                this.$bvToast.toast('Clé ' + this.key, {
                    variant: 'info',
                    title: "Traduction enregistrée",
                    autoHideDelay: 2000,
                    solid: true
                });
            },

            cancelEdit(e) {
                e.target.innerText = this.text;
                this.editMode = false;
            },
        }
    }
</script>

<style lang="scss">
    dfn {
        font-style: normal;
    }
    .editMode {
        border: 1px solid orange;
        min-width: 2em;
    }
    .frText {
        border: 1px solid #333;
        border-radius: 10px;
        margin-top: 0.2em;
        padding: 0.2em;
    }
    .frText:before {
        content: '🇫🇷';
    }
</style>
